const ROWS = 11;

export class ItemCardSerialsSidebar {
  constructor(element) {
    element.ItemCardSerialsSidebar = this;
    this._el = element;
    this._refs = {
      closeBtn: element.querySelector('[data-sidebar-close]'),
      heading: element.querySelector('[data-sidebar-heading]'),
      searchLabel: element.querySelector('[data-sidebar-search-label]'),
      searchInput: element.querySelector('[data-sidebar-search-input]'),
      grid: element.querySelector('[data-sidebar-grid]'),
      viewingLabel: element.querySelector('[data-sidebar-viewing-label]'),
      counter: element.querySelector('[data-sidebar-counter]'),
      footerSeparator: element.querySelector('[data-sidebar-footer-separator]'),
      showAllBtn: element.querySelector('[data-sidebar-show-all]'),
      showAllLabel: element.querySelector('[data-sidebar-show-all-label]'),
      footer: element.querySelector('[data-sidebar-footer]'),
    };

    this._allItems = [];
    this._visibleCount = ROWS * 3;
    this._counterLabel = '';
    this._columns = 3;
    this._triggerEl = null;

    this._addEventListeners();
  }

  _addEventListeners() {
    document.addEventListener('item-card-serials:open', (e) => {
      const {
        title,
        searchLabel,
        searchPlaceholder,
        items,
        counterLabel,
        showAllLabel,
        viewingLabel,
        columns,
      } = e.detail || {};

      this._allItems = items || [];
      this._columns = columns || 3;
      this._visibleCount = Math.min(ROWS * this._columns, this._allItems.length);
      this._counterLabel = counterLabel || '';

      if (this._refs.heading) this._refs.heading.textContent = title || '';
      if (this._refs.searchLabel) this._refs.searchLabel.textContent = searchLabel || '';
      if (this._refs.viewingLabel) this._refs.viewingLabel.textContent = viewingLabel || '';
      if (this._refs.searchInput) {
        this._refs.searchInput.placeholder = searchPlaceholder || '';
        this._refs.searchInput.value = '';
      }
      if (this._refs.showAllLabel) this._refs.showAllLabel.textContent = showAllLabel || '';

      this._render();

      if (!this._isOpen()) this._open();
    });

    if (this._refs.closeBtn) {
      this._refs.closeBtn.addEventListener('click', () => this._close());
    }

    if (this._refs.searchInput) {
      this._refs.searchInput.addEventListener('input', () => {
        this._visibleCount = ROWS * this._columns;
        this._render();
      });
    }

    if (this._refs.showAllBtn) {
      this._refs.showAllBtn.addEventListener('click', () => {
        this._visibleCount = this._getFilteredItems().length;
        this._render();
      });
    }

    this._el.addEventListener('click', (e) => {
      if (
        e.target === this._el ||
        e.target.classList.contains('item-card-serials-sidebar__overlay')
      ) {
        this._close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (!this._isOpen()) return;
      if (e.key === 'Escape') {
        this._close();
        return;
      }
      if (e.key === 'Tab') {
        const focusable = Array.from(
          this._el.querySelectorAll(
            'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
          ),
        ).filter((el) => !el.hidden);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  _getFilteredItems() {
    const query = this._refs.searchInput?.value.trim().toLowerCase() || '';
    if (!query) return this._allItems;
    return this._allItems.filter(
      (item) => typeof item === 'string' && item.toLowerCase().includes(query),
    );
  }

  _render() {
    const filtered = this._getFilteredItems();
    const visible = filtered.slice(0, this._visibleCount);
    const hasMore = this._visibleCount < filtered.length;

    if (this._refs.grid) {
      this._refs.grid.classList.toggle(
        'item-card-serials-sidebar__grid--single',
        this._columns === 1,
      );
      this._refs.grid.innerHTML = '';
      visible.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'item-card-serials-sidebar__grid-item';
        li.textContent = item;
        this._refs.grid.appendChild(li);
      });
    }

    if (this._refs.counter) {
      const ofLabel = this._refs.counter.dataset.ofLabel || 'of';
      this._refs.counter.textContent = `${visible.length} ${ofLabel} ${filtered.length} ${this._counterLabel}`;
    }

    if (this._refs.footer) {
      this._refs.footer.hidden = !hasMore;
    }
  }

  _isOpen() {
    return this._el.getAttribute('aria-hidden') === 'false';
  }

  _open() {
    this._triggerEl = document.activeElement;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    this._el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sidebar-open');
    if (this._refs.closeBtn) this._refs.closeBtn.focus();
  }

  _close() {
    this._el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sidebar-open');
    document.body.style.paddingRight = '';
    if (this._triggerEl) {
      this._triggerEl.focus();
      this._triggerEl = null;
    }
  }
}
